import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { EncSeries, Encoding, MarkType, MarkTypeOptions } from '@mode-vegas/vegas';
import { IconComponent } from '@mode/capra';
import { RenderDataModel } from '@mode/charts/util-vegas';
import { LayerOptionsMenuComponent } from '../layer-options/layer-options-menu.component';
import * as MarksHelpers from '../marks-helpers';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, LayerOptionsMenuComponent, MatLegacyMenuModule],
  selector: 'mode-layer-type-selector',
  templateUrl: './layer-type-selector.component.html',
  styleUrls: ['./layer-type-selector.component.scss'],
})
export class LayerTypeSelectorComponent implements OnChanges {
  @Input() series: EncSeries | undefined;
  @Input() renderModel: RenderDataModel | undefined;
  @Input() encoding: Encoding | undefined;
  @Input({ required: true }) markType!: MarkType | 'multiple';
  @Input() automatic = false;

  @Output() optionsChanged = new EventEmitter<MarkTypeOptions>();
  @Output() markTypeChanged = new EventEmitter<MarkType | 'automatic'>();

  isMarkTypeMenuOpen = false;
  dropdownText = '';

  iconMarkMap = MarksHelpers.IconMarkMap;

  markTypeDisabled = ['Square', 'Map', 'TotalArea', 'Shape'];
  supportedMarkTypes = Object.keys(MarkType).filter((x) => !this.markTypeDisabled.includes(x));

  ngOnChanges(changes: SimpleChanges): void {
    this.dropdownText = `${this.automatic ? 'Auto - ' : ''}${
      this.markType === 'multiple' ? 'Multiple' : this.markType
    }`;
  }

  onLayerOptionsChanged(options: MarkTypeOptions) {
    this.optionsChanged.emit(options);
  }

  setMarkType(type: MarkType | 'automatic') {
    this.markTypeChanged.emit(type);
  }
}
